module.exports = __webpack_public_path__ + "img/google_analytics_icon-v2.c5a52208.svg";